import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card","CardHeader","CardTitle","CardContent","CardFooter"] */ "/app/src/components/ui/Card.tsx");
